
const  savePacker = async ( data ) => {
    try {
        const response = await axios.post( "/packers/store", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
}

const getPacker = async (id) => {
    try {
        const response = await axios.get(`/packersResources/${id}`);
        return {data : response.data};
    } catch (error) {
        console.log("Error al obtener los datos", error);
        return {data : null, message: error.response.data.message};
    }
};

const updatePacker = async (data) => {
    try {
        const response = await axios.put(`/packersResources/${data.id}`, data);
        return {updated : true, message: response.data.message};
    } catch (error) {
        console.log("Error al actualizar los datos", error);
        return {updated : false, message: error.response.data.message};
    }
};

const deletePacker = async (id) => {
    try {
        const response = await axios.delete(`/packersResources/${id}`)
        return {deleted : true, message: response.data.message};
    } catch (error) {
        console.log("Error al eliminar los datos", error);
        return {deleted : false, message: error.response.data.message};
    }
};



export { savePacker, getPacker, deletePacker, updatePacker };